// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"644":"6a1a4217","732":"b8c9e0dc"}[chunkId] + ".chunk.js");